var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoAds = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.16 13a5.2 5.2 0 0 0-1.44-.2h-3.34v4.97l1.96-1.96v-1.18h1.18L24.16 13Zm-2.82 4.13v3h1.38a2.93 2.93 0 0 0 2.01-.8c.25-.24.45-.52.59-.85a2.87 2.87 0 0 0-.59-3.06 2.6 2.6 0 0 0-1.04-.63l1.41-1.42a4.53 4.53 0 0 1 2.09 2.22c.24.55.36 1.15.36 1.79a4.42 4.42 0 0 1-1.37 3.24 4.85 4.85 0 0 1-3.46 1.33h-3.34V19.1l1.96-1.96Zm-4.01 2.7-2.71-7.03h-2.23l-3.53 9.15h2.1l.78-2.09h3.53l.55 1.47 1.5-1.5Zm-.8 2.12 1.16-1.17.46 1.17h-1.63Zm-3-6.86h-.05l-1.09 3h2.23l-1.09-3Z",
  fill: "#ED0A34"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 24.04,
  y: 10.85,
  width: 1.6,
  height: 18.66,
  rx: 0.47,
  transform: "rotate(45 24.04 10.85)",
  fill: "#ED0A34"
})));
export { SvgNoAds as ReactComponent };